<template>
  <div
    class="lang-switch"
    :class="{ 'lang-switch--mobile': mobile, 'lang-switch--banner': banner }"
    role="group"
    :aria-label="ariaLabel"
  >
    <button
      v-for="lang in LOCALES"
      :key="lang.code"
      type="button"
      class="lang-btn"
      :class="{ active: locale === lang.code }"
      @click="setLocale(lang.code)"
    >
      {{ lang.label }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { LOCALES } from '~/composables/useI18n'

defineProps<{
  mobile?: boolean
  banner?: boolean
  ariaLabel: string
}>()

const { locale, setLocale } = useI18n()
</script>